(function($) {
    $.widget("ca.caTab", {
        options: {
            formWizard: {}
        },

        _create: function() {
            var formWizard = {
                disableUIStyles: true,
                inDuration: 0,
                outDuration: 0,
                disableInputFields: false
            };

            $.extend(formWizard, this.options.formWizard);

            var clickableWizard = this.element;
            /* Initialize Clickable Wizard */
            clickableWizard.formwizard(formWizard);

            clickableWizard.on('click', '.clickable-steps a', function(){
                var gotoStep = $(this).data('gotostep');

                clickableWizard.find('.step').hide();
                clickableWizard.find('#' + gotoStep).show();
            });
        }
    })
})(jQuery);
